import { isEqual } from "lodash";
import { createSelector } from "reselect";

import { getPassengersCountFromSelectedSeats } from "@app/modules/results/helpers/selected-seats";
import type { SelectedSeatsQueryParam } from "@app/modules/results/hooks/use-navigation";
import { getExperiments } from "@app/modules/results/selectors/state-accessors";
import { getTripById } from "@app/modules/results/selectors/trips/get-trip";
import type { ResultsReduxState } from "@app/types/results-redux-types";

import { getCartTripItem } from "./get-seat-selection-passenger-seats";

export const isCartValid = createSelector(
  [
    getCartTripItem,
    getExperiments,
    getTripById,
    (
      _state: ResultsReduxState,
      trip_id?: string,
      seats?: SelectedSeatsQueryParam
    ) => ({
      trip_id,
      seats
    })
  ],
  (trip_item, { SEAT_SELECTION_FIRST }, trip, { trip_id, seats }) => {
    // When on Async Cart view and only cart id is present in the URL, the trip_id can come from the cart item. Trips are only available during funnel navigation. After page refresh with a created cart, trips are not expected to be available.
    const is_trip_id_or_trip_missing = !trip_id || !trip;

    if (is_trip_id_or_trip_missing && trip_item) {
      return true;
    }

    if (!trip_item || !trip) {
      return false;
    }

    const segment_ids_in_cart = trip_item.segments.map(({ id }) => id);
    const segment_ids_in_trip = trip.segment_ids;
    if (!isEqual(segment_ids_in_cart, segment_ids_in_trip)) {
      return false;
    }

    if (SEAT_SELECTION_FIRST) {
      const passenger_count = getPassengersCountFromSelectedSeats(seats);
      if (trip_item.passengers.length !== passenger_count) {
        return false;
      }
    }

    return true;
  }
);
